import { JsonObject, JsonProperty } from 'json2typescript';


@JsonObject
export class ArchiveDefaultLearnCertConfigItem {
  @JsonProperty('archiveId', Number)
  archiveId: number = undefined;

  @JsonProperty('learnCertId', Object)
  learnCertId: number = undefined;

  constructor(archiveId?: number, learnCertId?: number) {
    this.archiveId = archiveId;
    this.learnCertId = learnCertId;
  }
}
